(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-registration/assets/react/pages/accountCreated/account-created.js') >= 0) return;  svs.modules.push('/modules/player-registration/assets/react/pages/accountCreated/account-created.js');
'use strict';

const _ReactRouterDOM = ReactRouterDOM,
  useHistory = _ReactRouterDOM.useHistory;
const Button = svs.ui.ReactButton;
const StepIndicatorBalls = svs.components.tb_ui.stepIndicatorBalls.StepIndicatorBalls;
const GridBase = svs.tb_ui_react.gridbase.GridBase;
const helpers = svs.playerRegistration.helpers;
const _svs$playerRegistrati = svs.playerRegistration.components,
  Header = _svs$playerRegistrati.Header,
  DesktopContentConstrain = _svs$playerRegistrati.DesktopContentConstrain,
  PageTitle = _svs$playerRegistrati.PageTitle,
  FadeInSlideWrapper = _svs$playerRegistrati.FadeInSlideWrapper;
const routes = svs.playerRegistration.constants.routes;
const NEW_CUSTOMER = 'NEW_CUSTOMER';
const RETAIL_CUSTOMER = 'RETAIL_CUSTOMER';
const NORMAL_CUSTOMER = 'NORMAL_CUSTOMER'; 

const customers = {
  NEW_CUSTOMER: {
    title: 'Nu har du ett spelkonto!',
    text: 'Använd spelkontot för att sätta in pengar och betala för spel. Här hamnar också dina vinster.'
  },
  RETAIL_CUSTOMER: {
    title: 'Bra att veta om ditt spelkonto',
    text: 'Använd spelkontot för att sätta in pengar och betala för spel. Här hamnar också dina vinster.'
  },
  NORMAL_CUSTOMER: {
    title: 'Sätt dina insättningsgränser',
    text: "Innan du kan betala beh\xF6ver du best\xE4mma hur mycket du vill kunna s\xE4tta in p\xE5 ditt spelkonto per m\xE5nad, vecka och dag.\n    Med spelkontot kan du betala f\xF6r spel och h\xE4r hamnar ocks\xE5 dina vinster."
  }
};
const AccountCreated = () => {
  const history = useHistory();
  const extraData = ReactRedux.useSelector(state => state.playerregistrationreact);
  const isRetailCustomer = ReactRedux.useSelector(state => state.playerregistrationreact.isRetailCustomer);
  const isInRegisterFlow = helpers.getIsInRegisterFlow(extraData === null || extraData === void 0 ? void 0 : extraData.setLimits);
  let customerType;
  if (!isInRegisterFlow) {
    customerType = NORMAL_CUSTOMER;
  } else if (isRetailCustomer) {
    customerType = RETAIL_CUSTOMER;
  } else {
    customerType = NEW_CUSTOMER;
  }
  const customer = customers[customerType];
  const navigateToNext = async () => {
    const returnUrl = helpers.getReturnUrl() || svs.core.urlMapping.get('newCustomer');
    const queryString = returnUrl ? "?returnUrl=".concat(encodeURIComponent(returnUrl)) : '';
    const depositLimitsUrl = "".concat(routes.DEPOSIT_LIMITS).concat(queryString);

    history.push(depositLimitsUrl);
  };
  const handleSubmit = async e => {
    e.preventDefault();
    navigateToNext();
  };
  svs.playerRegistration.logger.debug('KUND:    ', extraData);
  return React.createElement(React.Fragment, null, React.createElement(Header, null), React.createElement(DesktopContentConstrain, null, React.createElement(GridBase, null, React.createElement("div", {
    className: "margin-bottom-1"
  }, React.createElement(StepIndicatorBalls, {
    isActiveHidden: true,
    isLabelsHidden: true,
    isShowDottedLines: true,
    step: 2
  })), React.createElement(FadeInSlideWrapper, null, React.createElement("div", null, React.createElement("div", {
    className: "player-registration-account-created-icon margin-v-2"
  }), React.createElement(PageTitle, null, customer.title)), React.createElement("p", {
    className: "h4 margin-bottom-1"
  }, React.createElement("span", {
    className: "registration-bread-text"
  }, customer.text)), React.createElement("div", {
    className: "margin-top-2 margin-bottom-1"
  }, React.createElement(Button, {
    block: true,
    focus: true,
    onClick: handleSubmit,
    type: "submit"
  }, "Forts\xE4tt"))))));
};
svs.playerRegistration.pages.accountCreated.AccountCreated = AccountCreated;

 })(window);